import React, { useEffect, useState } from "react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../mensajes2";
import useTable from "../../useTableR";
import { Dimmer } from "../../spinner";
import { ImprimirPatente } from "./modalImprimirPatente";
import RenovacionLicenciaService from "./service/renovacionLicencia.service";
import ModalRechazarLicencia from "./ModalRechazarLicencia";

export const ActualizarRenovacion = (props) => {
  const op = require("../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const fechaActual = new Date();
  const fechaSistemaObj = fechaActual.toISOString();
  const fechaFormat = fechaSistemaObj.split("T")[0];
  const idUsuario = localStorage.getItem("idusuario");
  const idUsuarioLimpio = idUsuario ? idUsuario.replace(/^"|"$/g, "") : null;
  const anioActual = fechaActual.getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const [anioSeleccionado, setAnioSeleccionado] = useState(anioActual);
  const [seleccionarFiltro, setSeleccionarFiltro] = useState("por_aprob");
  const [datosTabla, setDatosTabla] = useState([]);
  const [mostrarPatente, setMostrarPatente] = useState(false);
  const [loading, setLoading] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [reversar, setReversar] = useState(false);
  const [mostrarMotivo, setMostrarMotivo] = useState({
    mostrar: false,
    consulta: false,
  });
  const [itemSelect, setItemSelect] = useState({
    index: -1,
    item: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
    reversar: false,
  });
  const [mensajesino2, setMensajesino2] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const filtroBusquea = [
    {
      id: "por_aprob",
      label: "Por Aprobación",
    },
    {
      id: "por_revi",
      label: "Por Revisión",
    },
    {
      id: "por_proce",
      label: "Por Procesar",
    },
    { id: "aprob_impr", label: "Aprobadas Impresas" },
    { id: "aprob_entre", label: "Aprobadas por Entregar" },
    { id: "entregadas", label: "Entregadas" },
    {
      id: "todas",
      label: "Todas",
    },
  ];
  const headCells = [
    {
      id: 0,
      label: "N°",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 1,
      label: "N° RITM",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 2,
      label: "Nombre",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 3,
      label: "Rif/Cedula",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 4,
      label: "Dirección",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 5,
      label: "Fecha",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 6,
      label: "Estatus",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: 7,
      label: "Opciones",
      width: "auto",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(datosTabla, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idrenovacion.includes(target.value) ||
              x.fechasolicitud
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.cedularif.toLowerCase().includes(target.value.toLowerCase()) ||
              x.direccion.toLowerCase().includes(target.value.toLowerCase()) ||
              x.status.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const obtenerTextoMensaje = (reversar) => {
    let texto = "";
    if (itemSelect.item.estatusrenovacion === 11) {
      setMostrarPatente(true);
      return;
    }
    if (reversar) {
      texto = `En este momento la Solicitud de Licencia de Funcionamiento se devolverá para su debida revisión, \n está seguro de devolver?`;
    } else {
      switch (itemSelect.item.estatusrenovacion) {
        case 1:
        case 12:
          texto = `En este momento se procederá a enviar la Solicitud de Renovación de Licencia de Actividades Económicas a Verificación, \n ¿Está seguro de enviar?`;
          break;

        case 2:
          texto = `En este momento la Solicitud de Renovación se enviará para su firma, \n ¿Está seguro de enviar?`;
          break;

        case 3:
          texto = `En este momento se procederá a formalizar la entrega de la Solicitud de Renovación, \n ¿Está seguro de formalizar dicha entrega?`;
          break;

        case 10:
          texto = `En este momento se procederá a enviar la Solicitud de Renovación de Licencia de Actividades Económicas para Procesar, \n ¿Está seguro de enviar?`;
          break;
      }
    }

    setMensajesino({
      mostrar: true,
      titulo: "",
      texto: texto,
      icono: "informacion",
      reversar: reversar,
    });
  };
  const obtenerTextoBoton = () => {
    switch (itemSelect.item.estatusrenovacion) {
      case 1:
      case 12:
        return "Cambiar Estatus a Por Revisión";
      case 2:
        return "Cambiar Estatus a Por RETIRAR";
      case 3:
        return "Cambiar Estatus a ENTREGADA";
      case 10:
        return "Cambiar Estatus a Por Procesar";
      case 11:
        return "Cambiar Estatus a Aprobadas Impresas";
      default:
        return null;
    }
  };
  const validarStatus = (status) => {
    try {
      switch (status) {
        case 1:
        case 12:
          return 10;
        case 10:
          return 11;
        case 11:
          return 2;
        case 2:
          return 3;
        case 3:
          return 4;
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Validar el Estatus de la Licencia",
        icono: "error",
      });
    }
  };
  const seleccionarFila = (item, index) => {
    try {
      setItemSelect({
        index: index,
        item: item,
      });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Seleccionar el Registro",
        icono: "error",
      });
    }
  };
  const buscarRegistros = async () => {
    try {
      setLoading(true);
      const res = await RenovacionLicenciaService.getAll(
        seleccionarFiltro,
        anioSeleccionado,
      );
      if (res.length > 0) {
        setDatosTabla(res);
        setItemSelect({ index: 0, item: res[0] });
      } else {
        setDatosTabla([]);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Buscar Registros",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const actualizarLicencia = async () => {
    try {
      if (itemSelect.item === "") {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al Actualziar la Licencia",
          icono: "error",
        });
        return;
      }
      const body = [
        {
          idrenovacion: itemSelect.item.idrenovacion,
          fechasolicitud: itemSelect.item.fechasolicitud,
          estatusrenovacion: reversar
            ? 12
            : validarStatus(itemSelect.item.estatusrenovacion),
          estatusnotificacion: itemSelect.item.estatusrenovacion === 2 ? 1 : 0,
        },
      ];
      if (reversar && motivo === "") {
        setMensaje({
          mostrar: true,
          titulo: "",
          texto: "El Motivo del Rechazo no Puede estar Vacio",
          icono: "informacion",
        });
        return;
      }
      body[0].motivorechazo = reversar ? motivo : null;
      body[0].rechazodia = reversar ? fechaSistemaObj : null;
      body[0].usuariorechaza = reversar ? parseInt(idUsuarioLimpio, 10) : null;
      const campos = `*`;
      const tabla = `actualizar_status_renovacion('${fechaSistemaObj}', '${JSON.stringify(body)}'::jsonb)`;
      const orden = `1`;
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${tabla}&orden=${orden}`;
      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.status === 200 && res.data.length > 0) {
            setMensaje({
              mostrar: true,
              titulo: "",
              texto: `Licencia N° ${itemSelect.item.idrenovacion} Actualizada Correctamente`,
              icono: "exito",
            });
            setItemSelect({
              index: -1,
              item: "",
            });
            buscarRegistros();
          }
        })
        .catch((error) => {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "Error al Actualziar la Licencia",
            icono: "error",
          });
        })
        .finally(() => {
          setLoading(false);
          setMostrarMotivo({
            mostrar: false,
            consulta: false,
          });
        });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Actualizar la Licencia",
        icono: "error",
      });
    }
  };
  const eliminarLicencia = async () => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/industria/eliminar-licencia-renovacion`;
      axios
        .post(
          endpoint,
          {
            idRenovacion: itemSelect.item.idrenovacion,
          },
          {
            headers: {
              "x-access-token": `${token}`,
              "Content-Type": "application/json",
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            buscarRegistros();
            setItemSelect({
              index: -1,
              item: "",
            });
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Licencia Eliminada Correctamente",
              icono: "exito",
            });
          }
        })
        .catch((err) => {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "Error al Eliminar la Licencia",
            icono: "error",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Eliminar la Licencia",
        icono: "error",
      });
    }
  };
  const imprimirReporte = (id) => {
    try {
      window.open(
        op.reportes +
          "/actividadeconomica?" +
          "reporte=SolicitudRenovacion" +
          `&ID=${id}&CONDICION=idrenovacion=${id}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Error al Imprimir la Licencia",
        icono: "error",
      });
    }
  };
  const cerrar = () => {
    blanquear();
    props.onHideCancela();
  };
  const blanquear = () => {};
  useEffect(() => {
    setItemSelect({
      index: -1,
      item: "",
    });
    buscarRegistros();
  }, [seleccionarFiltro, anioSeleccionado]);
  console.log(mostrarMotivo);
  return (
    <div
      className="mx-5 border-table"
      style={{
        marginTop: "3.5%",
      }}
    >
      <div className="py-0 text-uppercase">
        <header className="col-12 azulGradiant py-2 d-flex align-items-center justify-content-between text-light border-bottom">
          <h3 className="fw-bold text-light m-0">
            Solicitudes de Renovación de Licencia de Actividades Económicas.
          </h3>
          <button onClick={() => cerrar()} className="btn btn-sm bg-light">
            <i className="fa fa-times"></i>
          </button>
        </header>
        <div className="d-flex justify-content-between mx-1 px-1">
          <div className="col-3 input-group input-group-sm m-1 p-1 mr-auto">
            <input
              type="text"
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
              placeholder="Buscar Licencia..."
            />
          </div>
          <div className="col-md-3 mr-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Buscar por:
              </span>
              <select
                type="text"
                className="form-control text-uppercase"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                value={seleccionarFiltro}
                onChange={(e) => {
                  setSeleccionarFiltro(e.target.value);
                }}
              >
                {filtroBusquea.map((e, index) => (
                  <option key={index} value={e.id}>
                    {e.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-1 ml-auto row my-1 py-1">
            <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
              <span
                className="input-group-text text-uppercase"
                id="inputGroup-sizing-sm"
              >
                Año
              </span>
              <select
                type="text"
                className="form-control text-uppercase text-right"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                value={anioSeleccionado}
                onChange={(e) => setAnioSeleccionado(e.target.value)}
              >
                {anios.map((e, index) => (
                  <option key={index} value={e}>
                    {e}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <div style={{ maxHeight: "350px", overflowY: "auto" }}>
            <TblContainer>
              <TblHead />
              <tbody>
                {datosTabla && recordsAfterPagingAndSorting().length > 0 ? (
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        padding: "0",
                        cursor: "pointer",
                        background:
                          itemSelect.index === index ? "lightskyblue" : "white",
                      }}
                      onClick={(e) => {
                        seleccionarFila(item, index);
                      }}
                    >
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.idrenovacion}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.idcontribuyente}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "left",
                          width: "auto",
                        }}
                      >
                        {item.nombre}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.cedularif}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "left",
                          width: "auto",
                        }}
                      >
                        {item.direccion}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {
                          new Date(item.fechasolicitud)
                            .toISOString()
                            .split("T")[0]
                        }
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "auto",
                        }}
                      >
                        {item.status}
                      </td>
                      <td
                        className="align-baseline"
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          width: "120px",
                        }}
                      >
                        {item.estatusrenovacion === 12 && (
                          <button
                            type="button"
                            title="Ver Motivo del Rechazo"
                            style={{ fontSize: "11px" }}
                            className="btn btn-warning btn-sm rounded-pill mx-1"
                            onClick={() => {
                              seleccionarFila(item, index);
                              setMostrarMotivo({
                                mostrar: true,
                                consulta: true,
                              });
                            }}
                          >
                            <i className="fa fa-info-circle" />
                          </button>
                        )}
                        <button
                          type="button"
                          title="Ver Licencia"
                          style={{ fontSize: "11px" }}
                          className="btn btn-info btn-sm rounded-pill mx-1"
                          onClick={() => imprimirReporte(item.idrenovacion)}
                        >
                          <i className="fa fa-print" />
                        </button>
                        {(item.estatusrenovacion === 12 ||
                          item.estatusrenovacion === 1) && (
                          <button
                            type="button"
                            title="Eliminar Licencai"
                            style={{ fontSize: "11px" }}
                            className="btn btn-danger btn-sm rounded-pill mx-1"
                            onClick={() => {
                              seleccionarFila(item, index);
                              setMensajesino2({
                                mostrar: true,
                                titulo: "",
                                texto: `Esta Seguro de Eliminar la Licencia N° ${item.idrenovacion}?`,
                                icono: "informacion",
                              });
                            }}
                          >
                            <i className="fa fa-trash" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={8}
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        fontSize: "12px",
                        color: "#666",
                      }}
                    >
                      No hay registros disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </TblContainer>
          </div>
          <TblPagination />
        </div>
        <div className="d-flex justify-content-end m-2 gap-2">
          {itemSelect.item !== "" &&
            itemSelect.item.estatusrenovacion === 10 && (
              <button
                type="button"
                style={{ fontSize: "11px" }}
                className="btn btn-danger btn-sm rounded-pill"
                disabled={itemSelect.item === ""}
                onClick={() => {
                  obtenerTextoMensaje(true);
                  setReversar(true);
                }}
              >
                <i className="fa fa-refresh">
                  Devolver Status a Por Aprobación
                </i>
              </button>
            )}
          {obtenerTextoBoton() !== null && (
            <button
              type="button"
              style={{ fontSize: "11px" }}
              className="btn btn-info btn-sm rounded-pill"
              disabled={itemSelect.item === ""}
              onClick={() => {
                obtenerTextoMensaje(false);
              }}
            >
              <i className="fa fa-refresh">{obtenerTextoBoton()}</i>
            </button>
          )}
        </div>
      </div>
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={() => {
          mensajesino.reversar
            ? setMostrarMotivo({
                mostrar: true,
                consulta: false,
              })
            : actualizarLicencia();
          setMensajesino({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino2}
        onHideNo={() =>
          setMensajesino2({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          })
        }
        onHideSi={() => {
          eliminarLicencia();
          setMensajesino2({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <ImprimirPatente
        show={mostrarPatente}
        onHideCancela={() => setMostrarPatente(false)}
        onHideAcepta={() => {
          setMostrarPatente(false);
          actualizarLicencia();
        }}
        idcomercio={itemSelect.item.idcontribuyente}
        licencia={true}
      />
      <Dimmer active={loading} inverted />
      <ModalRechazarLicencia
        show={mostrarMotivo.mostrar}
        onHide={() =>
          setMostrarMotivo({
            mostrar: false,
            consulta: false,
          })
        }
        setMotivo={(e) => setMotivo(e)}
        onHideAcepta={() => actualizarLicencia()}
        consulta={mostrarMotivo.consulta}
        revisado={
          `${itemSelect.item.nombre_persona}` +
          " " +
          `${itemSelect.item.apellido_persona}`
        }
        motivo={itemSelect.item.motivorechazo}
        fecha={itemSelect.item.rechazodia}
      />
    </div>
  );
};
